import React from 'react';
interface GuaranteeSealProps {
  className?: string;
}

/** Sello de garantía de 60 días: anillo dorado, escudo y texto en arco. */
export function GuaranteeSeal({
  className = 'h-32 w-32'
}: GuaranteeSealProps) {
  return <svg viewBox="0 0 200 200" className={className} role="img" aria-label="Sello de garantía de devolución de dinero de 60 días" data-id="element-440" data-mp="1sea4lms6jta7">
      <defs data-id="element-441" data-mp="1ngif0zf0cj96">
        <path id="seal-arc-top" d="M 100 100 m -74 0 a 74 74 0 0 1 148 0" fill="none" data-id="element-442" data-mp="1ngs1id0ug8a4" />
        <path id="seal-arc-bottom" d="M 100 100 m 66 0 a 66 66 0 0 1 -132 0" fill="none" data-id="element-443" data-mp="21c41ozxrqqyf" />
      </defs>

      <circle cx="100" cy="100" r="96" fill="#1a472a" data-id="element-444" data-mp="1wd9gxsg8qsbo" />
      <circle cx="100" cy="100" r="88" fill="none" stroke="#d4af37" strokeWidth="2" data-id="element-445" data-mp="2b2ou25mumz8w" />
      <circle cx="100" cy="100" r="80" fill="none" stroke="#d4af37" strokeWidth="1" strokeDasharray="3 5" opacity="0.7" data-id="element-446" data-mp="264nc5o15t5z0" />

      <text fill="#d4af37" fontSize="15" fontWeight="700" fontFamily="Inter, sans-serif" letterSpacing="3.4" data-id="element-447" data-mp="2k57uyk72r1si">
        <textPath href="#seal-arc-top" startOffset="50%" textAnchor="middle" data-id="element-448" data-mp="2g4xqxd2uelga">
          GARANTÍA TOTAL
        </textPath>
      </text>

      <text fill="#d4af37" fontSize="11" fontWeight="600" fontFamily="Inter, sans-serif" letterSpacing="2.6" data-id="element-449" data-mp="seau75tnodsw">
        <textPath href="#seal-arc-bottom" startOffset="50%" textAnchor="middle" data-id="element-450" data-mp="xculllr0qhsn">
          DEVOLUCIÓN COMPLETA
        </textPath>
      </text>

      <g transform="translate(100 96)" data-id="element-451" data-mp="12e1rff9lp6wo">
        <path d="M0 -34 L26 -25 V-2 C26 15 14 27 0 33 C-14 27 -26 15 -26 -2 V-25 Z" fill="none" stroke="#d4af37" strokeWidth="2.5" data-id="element-452" data-mp="17bjs6idgsftl" />
        <text x="0" y="-4" textAnchor="middle" fill="#ffffff" fontSize="30" fontWeight="800" fontFamily="Inter, sans-serif" data-id="element-453" data-mp="1bc3ojjq7rfeo">
          60
        </text>
        <text x="0" y="14" textAnchor="middle" fill="#d4af37" fontSize="11" fontWeight="700" fontFamily="Inter, sans-serif" letterSpacing="1.5" data-id="element-454" data-mp="1g67y8aqv61jg">
          DÍAS
        </text>
      </g>
    </svg>;
}